const listingSteps = [
  {
    popover: {
      title: "Your Rides",
      description: "This page shows all rides you've posted and booked. Let's take a quick look.",
    },
  },
  {
    element: '[data-tour="listing-toggle"]',
    popover: {
      title: "Offered vs Booked",
      description: "Switch between rides you've offered (as a driver) and rides you've booked (as a passenger).",
    },
  },
  {
    element: '[data-tour="listing-rides"]',
    popover: {
      title: "Your Ride List",
      description: "Tap any ride to see its full details, manage passengers, or check your booking status.",
    },
  },
];

export default listingSteps;
